"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNAExtractionFromSoil = void 0;
var Tags_1 = require("../../Tags");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var Card_1 = require("../../Card");
var CardRenderer_1 = require("../../render/CardRenderer");
var ResourceType_1 = require("../../../ResourceType");
var SelectOption_1 = require("../../../inputs/SelectOption");
var OrOptions_1 = require("../../../inputs/OrOptions");
var DNAExtractionFromSoil = (function (_super) {
    __extends(DNAExtractionFromSoil, _super);
    function DNAExtractionFromSoil() {
        var _this = _super.call(this, {
            cost: 6,
            tags: [Tags_1.Tags.MICROBE],
            name: CardName_1.CardName.DNA_EXTRACTION_FROM_SOIL,
            cardType: CardType_1.CardType.ACTIVE,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            metadata: {
                cardNumber: 'L415',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 microbe to this card, or remove 1 microbe here to draw a card.', function (eb) {
                        eb.empty().arrow().microbes(1).or();
                        eb.microbes(1).startAction.cards(1);
                    });
                }),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    DNAExtractionFromSoil.prototype.play = function () {
        return undefined;
    };
    DNAExtractionFromSoil.prototype.canAct = function () {
        return true;
    };
    DNAExtractionFromSoil.prototype.action = function (player) {
        var _this = this;
        if (this.resourceCount < 1) {
            player.addResourceTo(this, 1);
            return undefined;
        }
        var opts = [];
        var addResource = new SelectOption_1.SelectOption('Add 1 microbe on this card', 'Add microbe', function () { return _this.addResource(player); });
        var spendResource = new SelectOption_1.SelectOption('Remove 1 microbe on this card to draw a card', 'Remove microbe', function () { return _this.spendResource(player); });
        opts.push(spendResource);
        opts.push(addResource);
        return new (OrOptions_1.OrOptions.bind.apply(OrOptions_1.OrOptions, __spreadArray([void 0], opts)))();
    };
    DNAExtractionFromSoil.prototype.addResource = function (player) {
        player.addResourceTo(this, 1);
        return undefined;
    };
    DNAExtractionFromSoil.prototype.spendResource = function (player) {
        this.resourceCount--;
        player.drawCard();
        return undefined;
    };
    return DNAExtractionFromSoil;
}(Card_1.Card));
exports.DNAExtractionFromSoil = DNAExtractionFromSoil;
//# sourceMappingURL=DNAExtractionFromSoil.js.map